import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/es/politica-de-privacidad")({
  head: () => buildRouteHead("/es/politica-de-privacidad"),
  component: PrivacyPolicy,
});

